import { Pipe, type PipeTransform } from '@angular/core';
import { GravatarOptions } from 'src/app/angie-shared/components/gravatar/gravatar.models';
import { LiveSessionInstructor } from 'src/app/modules/live-learning/models/live-learning.model';
import { SessionInstructor } from '../../learner-dashboard/models';

@Pipe({
	name: 'getMappedInstructor',
	standalone: true
})
export class GetMappedInstructorPipe implements PipeTransform {
	transform(instructors: SessionInstructor[] | LiveSessionInstructor[], sizeClass = 'sqr-img--md'): GravatarOptions[] {
		if (!instructors?.length) {
			return [];
		}
		const mappedInstructors = instructors.map(instructor => {
			return {
				altTag: instructor.alt_tag,
				displayName: instructor.display_name,
				largeImageUrl: instructor?.large_image_url || instructor?.large_url,
				smallImageUrl: instructor?.small_image_url || instructor?.small_url,
				gravatarClass: sizeClass,
				initialsClass: sizeClass
			} as GravatarOptions;
		});
		return mappedInstructors;
	}
}
